export default __webpack_public_path__ + "static/media/Curve.ab082ba8.webp";